module.exports = __webpack_public_path__ + "static/media/comming soon.999afd5f.jpg";